export default __webpack_public_path__ + "static/media/check-icon.355777e8.svg";